"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Certiblok Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailApi = exports.EmailApiFactory = exports.EmailApiFp = exports.EmailApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * EmailApi - axios parameter creator
 * @export
 */
const EmailApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Retry email
         * @param {InputRetryEmail} [inputRetryEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryEmail: (inputRetryEmail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/email/retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputRetryEmail, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Send base email
         * @param {InputSendBaseEmail} [inputSendBaseEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBaseEmail: (inputSendBaseEmail, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/email/send-base`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication headerAuth required
            yield (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "authorization", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inputSendBaseEmail, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EmailApiAxiosParamCreator = EmailApiAxiosParamCreator;
/**
 * EmailApi - functional programming interface
 * @export
 */
const EmailApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EmailApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retry email
         * @param {InputRetryEmail} [inputRetryEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryEmail(inputRetryEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retryEmail(inputRetryEmail, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Send base email
         * @param {InputSendBaseEmail} [inputSendBaseEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBaseEmail(inputSendBaseEmail, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendBaseEmail(inputSendBaseEmail, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EmailApiFp = EmailApiFp;
/**
 * EmailApi - factory interface
 * @export
 */
const EmailApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EmailApiFp)(configuration);
    return {
        /**
         *
         * @summary Retry email
         * @param {InputRetryEmail} [inputRetryEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryEmail(inputRetryEmail, options) {
            return localVarFp.retryEmail(inputRetryEmail, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send base email
         * @param {InputSendBaseEmail} [inputSendBaseEmail]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBaseEmail(inputSendBaseEmail, options) {
            return localVarFp.sendBaseEmail(inputSendBaseEmail, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EmailApiFactory = EmailApiFactory;
/**
 * EmailApi - object-oriented interface
 * @export
 * @class EmailApi
 * @extends {BaseAPI}
 */
class EmailApi extends base_1.BaseAPI {
    /**
     *
     * @summary Retry email
     * @param {InputRetryEmail} [inputRetryEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    retryEmail(inputRetryEmail, options) {
        return (0, exports.EmailApiFp)(this.configuration).retryEmail(inputRetryEmail, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Send base email
     * @param {InputSendBaseEmail} [inputSendBaseEmail]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailApi
     */
    sendBaseEmail(inputSendBaseEmail, options) {
        return (0, exports.EmailApiFp)(this.configuration).sendBaseEmail(inputSendBaseEmail, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EmailApi = EmailApi;
